import { createRouter, createWebHistory } from 'vue-router'
import Login from '../pages/Login/Login.vue'
import Dashboard from '../pages/Dashboard/Dashboard.vue'
import NewJob from '../pages/NewJob/NewJob.vue'
import Register from '../pages/Register/Register.vue'
import BaseLayout from '../components/BaseLayout.vue'
import JobHistory from '../pages/JobHistory/JobHistory.vue'
import ViewDocument from '../pages/ViewDocument/ViewDocument.vue'
import OtpVerification from '@/pages/OtpVerification/OtpVerification.vue'
import ForgotPassword from '@/pages/ForgotPassword/ForgotPassword.vue'
import UsersManagement from '@/pages/UsersManagement/UsersManagement.vue'
import CreateUser from '@/pages/CreateUser/CreateUser.vue'
import TenantManagement from '@/pages/TenantManagement/TenantManagement.vue'
import Configure from '@/pages/Configure/Configure.vue'
import Departments from '@/pages/Departments/Departments.vue'
import EditUser from '@/pages/EditUser/EditUser.vue'
import TenantUsers from '@/pages/UsersManagement/TenantUsers.vue'
import EditTenant from '@/pages/EditTenant/EditTenant.vue'
import UploadStatus from '@/pages/uploadStatus/uploadStatus.vue'
import UpdateUser from '@/pages/UpdateUser/UpdateUser.vue'
import ExtractionFields from '@/pages/ExtractionFields/ExtractionFields.vue'
import Models from '@/pages/Models/Models.vue'
import IDPDocumentClasses from '@/pages/IDPDocumentClasses/IDPDocumentClasses.vue'
import DocumentType from '@/pages/DocumentType/DocumentType.vue'
import CategoriesGrid from '@/pages/Categories/CategoriesGrid.vue'
import EditBlueprint from '@/pages/EditBlueprint/EditBlueprint.vue'
import CategoryDetails from '@/pages/Categories/CategoryDetails.vue'
import TenantLogin from '@/pages/TenantLogin/TenantLogin.vue'
import ChangeLanguage from '../pages/Language/ChangeLanguage.vue'
import Uploads from '../documentTraning/src/views/Uploads.vue'
import Reports from '@/pages/Reports/Reports.vue'
import Help from '@/pages/Help/Help.vue'

const routes = [
  { path: '/', redirect: '/login' },

  // Public routes (no tenantName)
  { path: '/login', component: Login, name: 'Login' },
  { path: '/register', name: 'Register', component: Register },
  { path: '/otp-verification', component: OtpVerification, name: 'OtpVerification' },
  { path: '/forgot-password', component: ForgotPassword, name: 'ForgotPassword' },
  { path: '/tenant/:tenantSlug', component: TenantLogin, name: 'TenantLogin' },
  { path: '/update-user', component: UpdateUser, name: 'UpdateUser' },

  // Dynamic tenant scoped routes
  {
    path: '/:tenantName',
    component: BaseLayout,
    meta: { requiresAuth: true },
    children: [
      { path: 'dashboard', component: Dashboard, name: 'dashboard' },
      { path: 'users-management', component: UsersManagement, name: 'UsersManagementName' },
      { path: 'tenant-management', component: TenantManagement, name: 'TenantManagementName' },
      { path: 'create-user', component: CreateUser, name: 'CreateUserName' },
      { path: 'tenant/add', component: EditTenant, name: 'CreateTenantName' },
      { path: 'tenant/edit/:id', component: EditTenant, name: 'EditTenantName' },
      { path: 'new-job', component: NewJob, name: 'new-job' },
      { path: 'job-history', component: JobHistory, name: 'job-history' },
      { path: 'departments', component: Departments, name: 'DepartmentsName' },
      { path: 'edit-user/:id', component: EditUser, name: 'EditUserName' },
      { path: 'tenant-users/:id/:tenantDisplayName', component: TenantUsers, props: true, name: 'TenantUsersName' },
      { path: 'upload-status', component: UploadStatus, name: 'UploadStatusName' },
      { path: 'view-document', component: ViewDocument, name: 'view-document' },

      {
        path: 'configure',
        component: Configure,
        children: [
          { path: 'categories', component: CategoriesGrid, name: 'ConfigureCategories' },
          { path: 'categories/:id', component: CategoryDetails, name: 'CategoryDetails' },
          { path: 'departments', component: Departments, name: 'ConfigureDepartments' },
          { path: 'document-types', component: DocumentType, name: 'ConfigureDocumentTypes' },
          { path: 'extraction-fields', component: ExtractionFields, name: 'ConfigureExtractionFields' },
          { path: 'models', component: Models, name: 'ConfigureModels' },
          { path: 'idp-document-classes', component: IDPDocumentClasses, name: 'ConfigureIDPDocumentClasses' },
          { path: 'edit-blueprint/:id', component: EditBlueprint, name: 'EditBlueprint' },
        ],
      },

      // Reports with child routing
      {
        path: 'reports',
        component: Reports,
        name: 'Reports',
        children: [
          {
            path: '',
            redirect: { name: 'ReportType', params: { reportType: 'audit' } },
          },
          {
            path: ':reportType',
            component: Reports,
            name: 'ReportType',
            props: true,
          },
        ],
      },

      { path: 'change-language', component: ChangeLanguage, name: 'ChangeLanguage' },
      { path: 'document-training', component: Uploads, name: 'DocumentTraining' },
      { path: 'edit-blueprint', component: () => import('../documentTraning/src/views/EditBlueprint.vue'), name: 'EditBlueprint' },
      { path: 'help', component: Help, name: 'Help' },
    ],
  },

  // Fallback
  { path: '/:pathMatch(.*)*', redirect: '/login' },
]

const router = createRouter({
  history: createWebHistory(),
  routes,
})

router.beforeEach((to, from, next) => {
  const token = localStorage.getItem('AccessToken')
  const isAuthenticated = !!token
  if (to.meta.requiresAuth && !isAuthenticated) {
    next({
      path: '/login',
      query: { message: 'Please login again to continue.' },
    })
  } else {
    next()
  }
})

export default router
